const regAbsolute = /^([a-z]+:\/\/|\/\/)/i;

/**
 * Returns true if the href points to a domain that is not the current tenant.
 * Relative URLs (/path) are always considered internal.
 */
export const isExternalUrl = (href: string, domain: string): boolean => {
  if (!regAbsolute.test(href)) return false;
  try {
    const absolute = href.startsWith('//') ? `https:${href}` : href;
    const { hostname } = new URL(absolute);
    const tenantHost = `www.${domain}`;
    const clientHost = typeof window !== 'undefined' ? window.location.hostname : undefined;
    return hostname !== tenantHost && hostname !== 'localhost' && hostname !== clientHost;
  } catch {
    return true;
  }
};
